import React from 'react';

import { Grid, Typography, makeStyles, Divider } from '@material-ui/core';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import {
  PeriodCountAccess,
  DateFilterFields,
} from 'modules/environments/interfaces';
import { isClientOperator } from 'utils/role';
import { RolesEnum } from 'modules/authenticate/interfaces';
import { filterPeriodOptions } from 'utils/graphs';
import FilterSelector from 'components/FilterSelector';
import { getDashboardSessionsGraphRequest } from 'modules/environments/actions';
import i18n from 'i18n';
import { useParams } from 'react-router';
import DateFilter from 'components/DateFilter';
import SessionHistoryGraph from './SessionHistoryGraph';
import styles, { overrideFilter } from './styles';

interface SessionHistoryModalProps {
  periodFilter: PeriodCountAccess;
  role?: RolesEnum;
  getDashboardSessionsGraphRequest: ({ id, query }) => void;
}

const SessionHistoryModal = ({
  periodFilter,
  role,
  getDashboardSessionsGraphRequest,
}: SessionHistoryModalProps) => {
  const { id } = useParams<{
    id: string;
  }>();
  const classes = makeStyles(styles())();

  const [period, setPeriod] = React.useState<PeriodCountAccess | string>(
    periodFilter
  );
  const [dateFilter, setDateFilter] = React.useState<DateFilterFields>({
    'start-date': '',
    'end-date': '',
  });
  const [openDateFilter, setOpenDateFilter] = React.useState(false);

  React.useEffect(() => {
    const query =
      dateFilter?.['start-date'] && dateFilter?.['end-date']
        ? dateFilter
        : { period };

    getDashboardSessionsGraphRequest({ id, query });
  }, [getDashboardSessionsGraphRequest, id, period, dateFilter]);

  return (
    <Grid container className={classes.modalGraph}>
      <Grid container className={classes.legend}>
        <Grid item className={classes.filtersContainer}>
          <DateFilter
            onOpenFilter={setOpenDateFilter}
            onSubmit={setDateFilter}
          />
          {!openDateFilter && (
            <FilterSelector
              overrideClasses={overrideFilter}
              options={filterPeriodOptions(setPeriod)}
              currentValue={{
                label: i18n.t(
                  `ENVIRONMENT_DASHBOARD.LAST_${period.toUpperCase()}`
                ),
                onClick: () => null,
              }}
            />
          )}
        </Grid>
        <Grid className={classes.legendContainer}>
          <Divider
            variant="middle"
            orientation="vertical"
            className={classes.divider}
          />
          <Grid item className={classes.labelsModal}>
            <FiberManualRecordIcon className={classes.graphSessionsMax} />
            <Typography className={classes.graphLegendItem}>
              {i18n.t('ENVIRONMENT_DASHBOARD.SESSIONS_MAX_KEY')}
            </Typography>
          </Grid>
          {!isClientOperator(role) && (
            <Grid item className={classes.labelsModal}>
              <FiberManualRecordIcon className={classes.graphVacanciesMax} />
              <Typography className={classes.graphLegendItem}>
                {i18n.t('ENVIRONMENT_DASHBOARD.VACANCIES_MAX_KEY')}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      <SessionHistoryGraph isModal />
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { data },
  environments: { periodFilter },
}: ApplicationState) => ({
  role: data?.role,
  periodFilter,
});

export default connect(mapStateToProps, {
  getDashboardSessionsGraphRequest,
})(SessionHistoryModal);
